import { render, staticRenderFns } from "./BinMovement.vue?vue&type=template&id=1948714c&"
import script from "./BinMovement.vue?vue&type=script&lang=js&"
export * from "./BinMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports